"use strict";
var ko = require("knockout");
ko.bindingHandlers["checkedWithInit"] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var observable = valueAccessor();
        var value = $(element).attr("checked");
        if (!ko.isWriteableObservable(observable)) {
            throw new Error("Observable should be writeable");
        }
        if (value) {
            observable(value);
        }
        var bindings = {
            checked: observable
        };
        ko.applyBindingsToNode(element, bindings, viewModel);
    }
};
ko.bindingHandlers["radioWithInit"] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var observable = valueAccessor();
        var value = $(element).attr("checked");
        if (!ko.isWriteableObservable(observable)) {
            throw new Error("Observable should be writeable");
        }
        if (value) {
            observable($(element).val());
        }
        var bindings = {
            checked: observable
        };
        ko.applyBindingsToNode(element, bindings, viewModel);
    }
};
ko.bindingHandlers["checkedArrayWithInit"] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var observable = valueAccessor();
        var isChecked = $(element).attr("checked");
        if (!ko.isWriteableObservable(observable)) {
            throw new Error("Observable should be writeable");
        }
        if (isChecked) {
            var values = observable();
            values.push($(element).val());
            observable(values);
        }
        var bindings = {
            checked: observable
        };
        ko.applyBindingsToNode(element, bindings, viewModel);
    }
};
//# sourceMappingURL=ko.checkedWithInit.js.map